import * as React from 'react';

const SvgSocialTwitter: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.919 20.876c8.302 0 12.842-6.878 12.842-12.843 0-.195 0-.39-.013-.583A9.185 9.185 0 0023 5.114a9.01 9.01 0 01-2.593.71 4.53 4.53 0 001.985-2.497 9.047 9.047 0 01-2.866 1.096A4.52 4.52 0 0016.235 3c-2.479 0-4.518 2.04-4.518 4.518 0 .344.039.686.117 1.021A12.82 12.82 0 012.53 3.824 4.536 4.536 0 003.93 9.849a4.48 4.48 0 01-2.049-.565v.057c0 2.14 1.523 4 3.621 4.425a4.508 4.508 0 01-2.038.077 4.528 4.528 0 004.217 3.135A9.058 9.058 0 011 18.848a12.78 12.78 0 006.919 2.025"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgSocialTwitter;
